import { useState, useCallback, useEffect } from "react";
import { api } from "@lib/orpc-client";
import * as Sentry from "@sentry/react";

type Source = "REDEMPTION" | "PAYMENT";

const useFavoritePaymentBanks = (source: Source = "PAYMENT") => {
  const [favorites, setFavorites] = useState<Set<string>>(new Set());

  useEffect(() => {
    const fetcher =
      source === "PAYMENT"
        ? api.wallet.banking.listPayment({})
        : api.wallet.banking.list({});
    fetcher
      .then((list) => {
        setFavorites(
          new Set(list.filter((b) => b.is_favorite).map((b) => b.bank_uuid))
        );
      })
      .catch(Sentry.captureException);
  }, [source]);

  const toggleFavorite = useCallback(
    (bankId: string) => {
      const previousFavorites = new Set(favorites);
      const nextFavorites = new Set(favorites);
      const nextValue = !nextFavorites.has(bankId);

      if (nextValue) {
        nextFavorites.add(bankId);
      } else {
        nextFavorites.delete(bankId);
      }

      setFavorites(nextFavorites);

      api.walletV2.banking
        .favorite({ bank_uuid: bankId, is_favorite: nextValue })
        .catch((err) => {
          setFavorites(previousFavorites);
          Sentry.captureException(err);
        });
    },
    [favorites]
  );

  const isFavorite = useCallback(
    (bankId: string) => favorites.has(bankId),
    [favorites]
  );

  return { isFavorite, toggleFavorite };
};

export default useFavoritePaymentBanks;
